import {} from 'react';
import { useKey } from 'react-use';
import { EventKeyValues } from 'constants/events';
const useEscapeKeyPressed = (callback, target, deps) => {
    useKey(EventKeyValues.ESCAPE, callback, { event: 'keyup', target: target || document }, deps);
};
export default useEscapeKeyPressed;
